// let iframe = document.querySelector('iframe[src*="player.vimeo.com"]');

// if (iframe) {
//     let player = new Vimeo.Player(iframe);

//     player.ready().then(() => {
//       player.getDuration().then((data) => console.log("TIME: "+ convertSecondstoTime(data)));
//     }).catch((err) => console.log(err));
// }

// function convertSecondstoTime(numSecs) {
//     const sec = parseInt(numSecs, 10); // convert numSecs to number if it's string
//     let hours   = Math.floor(sec / 3600); // get hours
//     let minutes = Math.floor((sec - (hours * 3600)) / 60); // get minutes
//     let seconds = sec - (hours * 3600) - (minutes * 60); //  get seconds
//     // add 0 if numSecs < 10; Example: 2 => 02
//     if (hours   < 10) {hours   = "0"+hours;}
//     if (minutes < 10) {minutes = "0"+minutes;}
//     if (seconds < 10) {seconds = "0"+seconds;}

//     return ((hours == '00') ? '' : hours + ":") + minutes + ':' + seconds;
// }

// Load Vimeo on click Playbutton in Preview Image:

const playButton = document.querySelector('.video__play');

if (playButton) {
    playButton.addEventListener('click', () => {
        const wrapper = document.querySelector('.video-container');
        const videoId = playButton.dataset.video;
        if (wrapper && videoId) {
            wrapper.innerHTML =
                '<div class="video-container__vimeo" style="padding:56.25% 0 0 0;position:relative;"><iframe class="vimeo-iframe" src="https://player.vimeo.com/video/' +
                videoId +
                '?h=d446ec0ce8&amp;badge=0&amp;autopause=0&amp;autoplay=1&amp;" webkitAllowFullScreen mozallowfullscreen allowFullScreen frameborder="0"  allow="autoplay; fullscreen; picture-in-picture" allowfullscreen style="position:absolute;top:0;left:0;width:100%;height:100%;border-radius: 5px;"></iframe></div>';
        }
    });
}
